import React from "react";
import { CourseValidationErrors } from "@src/features/libraryItem/course/types/validation";

import { ViewingMode } from "../../shared/CourseOutlineCenterContentWrapper";
import { SkillValidationErrors } from "@src/features/libraryItem/skill/utils/validation";
import { ContentQrCodeFragment } from "@src/fragments.generated";

export type ModuleBuilderContextState = {
  skillValidationErrors: SkillValidationErrors;
  activeMembershipUuid: string | undefined;
  setActiveMembershipUuid: (itemId: string) => void;
  viewingMode: ViewingMode;
  setViewingMode: (viewingMode: ViewingMode) => void;
  onSelectHomeScreen: () => void;
  isHomeScreenSelected: boolean;
  setIsHomeScreenSelected: (isHomeScreenSelected: boolean) => void;
  marketplaceModule: boolean;
  aiModuleGenerating: boolean;
  aiSCORMUploading: boolean;
  aiSCORMError: boolean;
  moduleQRCode: ContentQrCodeFragment | null | undefined;
  setModuleQrCode: (qrCode: ContentQrCodeFragment) => void;
};
export const ModuleBuilderContext = React.createContext<
  ModuleBuilderContextState | undefined
>(undefined);

export type ModuleValidationErrors = {
  courseIdToValidationErrors: Map<number, CourseValidationErrors>;
  skillIdToValidationErrors: Map<number, SkillValidationErrors>;
  duplicateMembershipUuids: Set<string>;
  courseOutlineIds: Array<string>;
  emptySectionBreakUuids: Set<string>;
};
